<template>
  <validation-observer v-bind="$attrs" v-slot="slots">
    <slot
      v-bind="slots"
      :handleSubmit="
        (submit: () => void) => handleCrossSubmit(slots.handleSubmit, submit)
      "
    />
  </validation-observer>
</template>

<script lang="ts">
import { computed, defineComponent, nextTick } from "vue";

/**
 * データ全体を見なければいけない相関チェックを行う場合に使用するValidationProvider.
 * vee-validateのValidationProviderのラッパーなので置き換えて使用する（propsやslotプロパティも同一）
 *
 * このコンポーネント内でCrossValidationProviderが使用できるようになる
 * 相関チェックでエラーが発生するとhandlerSubmitをコールしないようにしてくれる
 */
export default defineComponent({
  name: "CrossValidationObserver",
  data() {
    return {
      /** true: submitされた, false: submitされてない */
      submitted: false,
      /** vid毎の相関チェックの成否 */
      passed: {} as Record<string, boolean>,
    };
  },
  provide() {
    return {
      addValidateState: this.addValidateState,
      // リアクティブにする
      provideData: computed(() => {
        return { submitted: this.submitted };
      }),
    };
  },
  methods: {
    /**
     * validation-observerのhandleSubmitをoverrideするhandle.
     * 相関チェック結果の有無によってsubmitする/しないを制御する
     * @param handleSubmit 既存のhandleSubmit
     * @param submit 画面のsubmit
     */
    async handleCrossSubmit(
      handleSubmit: (submit?: unknown) => Promise<void>,
      submit: () => void
    ) {
      this.submitted = true;
      // 通常のバリデーションを起動させるためにhandleSubmitを引数なしで呼び出す
      await handleSubmit();

      // CallBackで実施するので、awaitはいらない
      nextTick(async () => {
        // 相関チェックでエラーが1件でも存在する場合はsubmitをキャンセル
        if (Object.values(this.passed).filter((e) => !e).length >= 1) {
          return;
        }
        await handleSubmit(submit);
      });
    },

    /**
     * 相関チェックの結果を記録
     * @param vid 識別子
     * @param passed true: valid: false: invalid
     */
    addValidateState(vid: string, passed: boolean) {
      this.passed[vid] = passed;
    },
  },
});
</script>
